<template>
  <div>
      <file-pond
        name="test"
        ref="pond"
        label-idle="<small style='font-size: 12px'>Arrastra tus imágenes aquí...</small>"
        accepted-file-types="image/jpeg, image/png"
        v-on:addfile="handleUpload"
        v-on:removefile="handleCancel"
      />
  </div>
</template>

<script>
// Import Vue FilePond
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

// // Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";

// // Create component
const FilePond = vueFilePond(
  FilePondPluginImagePreview,
  FilePondPluginFileEncode,
);

export default {
  name: "ImageUpload",
  data: function () {
    return {
      img: "",
      resizedImage: null,
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(this.$refs.pond.getFile().getFileEncodeBase64String());
      console.log(this.$refs.pond.getFile().getFileEncodeDataURL());
    },
    handleUpload() {
      this.$emit("upload", this.$refs.pond.getFile().getFileEncodeDataURL());
    },
    handleCancel() {
      this.$emit("cancel")
    }
  },
  components: {
    FilePond,
  },
};
</script>

<style lang="scss">
.cropper__container {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 99999;
  background-color: rgba(31, 27, 27, 0.7);
  backdrop-filter: blur(10px);
  padding: 0 10px;

  .cropper__body {
    max-width: 800px;
    margin: 0 auto;
    margin-top: 30px;
  }
}
</style>
